import authInitState from "containers/authentication/redux/initialState";
import { backgroundOperationsInitialState as backgroundOperationsInitState } from "containers/background-operations/redux/sliceTypes";
import eventsInitState from "containers/calendar/redux/initialState";
import clientsInitState from "containers/clients/redux/initialState";
import customersInitState from "containers/customers/redux/initialState";
import dashboardInitState from "containers/dashboards/redux/initialState";
import documentsInitState from "containers/documents/redux/initialState";
import environmentInitState from "containers/environments/redux/initialState";
import discountsState from "containers/erp/redux/discounts/initialState";
import erpOrdersState from "containers/erp/redux/orders/initialState";
import stockState from "containers/erp/redux/stock/initialState";
import stockMovementColumnState from "containers/erp/redux/stock_movements/initialState";
import storagesInitState from "containers/erp/redux/storages/initialState";
import foldersInitState from "containers/folders/redux/initialState";
import listsInitState from "containers/lists/redux/initialState";
import { notificationsInitialState as notificationsInitState } from "containers/notifications/sliceTypes";
import ordersState from "containers/panorama/redux/initialState";
import { initialPictureFeedbackState } from "containers/pictures/redux/feedback/types";
import teamsInitState from "containers/teams/redux/initialState";
import { initialState as territoriesInitState } from "containers/territories/redux";
import usersInitState from "containers/users/redux/reducer/initialState";
import workflowsInitState from "containers/workflows/redux/initialState";
import IMetaExpressionInitState from "containers/workflows/redux/meta_expressions/initialState";
import triggersState from "containers/workflows/redux/triggers/initialState";
import webhooksState from "containers/workflows/redux/webhooks/initialState";
import jobsInitState from "containers/workflows/subcategories/jobs/redux/initialState";
import ajaxInitState from "redux/reducers/ajaxInitialState";
import appInitState from "redux/reducers/appInitialState";
import tableConfigState from "redux/reducers/tableInitialState";

import IRootState from "./store/model";

const fullInitState: IRootState = {
  app: appInitState,
  triggers: triggersState,
  webhooks: webhooksState,
  orders: ordersState,
  erpOrders: erpOrdersState,
  stock: stockState,
  discounts: discountsState,
  ajax: ajaxInitState,
  dashboards: dashboardInitState,
  jobs: jobsInitState,
  meta_expressions: IMetaExpressionInitState,
  environments: environmentInitState,
  teams: teamsInitState,
  auth: authInitState,
  background_operations: backgroundOperationsInitState,
  documents: documentsInitState,
  lists: listsInitState,
  notify: notificationsInitState,
  customers: customersInitState,
  users: usersInitState,
  workflows: workflowsInitState,
  clients: clientsInitState,
  folders: foldersInitState,
  territories: territoriesInitState,
  calendar_events: eventsInitState,
  table: tableConfigState,
  stock_movements: stockMovementColumnState,
  pictureFeedback: initialPictureFeedbackState,
  storages: storagesInitState,
};

export default fullInitState;
